import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { UserSessionService } from 'src/app/services/usersession.service';
import { DataService } from 'src/app/services/data.service';
import { ActivatedRoute, RouteConfigLoadEnd, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { Overlay } from '@angular/cdk/overlay';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RegionService } from 'src/app/services/region.service';
import { AlertService } from 'src/app/services/alert.service';
import * as _ from 'lodash';
import * as moment from 'moment';

export const MY_CUSTOM_FORMATS = {
    fullPickerInput: 'DD-MM-YYYY',
    datePickerInput: 'DD-MM-YYYY',
    timePickerInput: 'LT',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
};

import { GanttEditorComponent, GanttEditorOptions } from "ng-gantt";
import { RegisterService } from 'src/app/services/register.service';
import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { MomentDateTimeAdapter } from 'ng-pick-datetime-moment';
@Component({
    selector: 'app-master-popup',
    templateUrl: './master-popup.component.html',
    styleUrls: ['./master-popup.component.scss'],
    providers: [
        { provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },
        { provide: OWL_DATE_TIME_FORMATS, useValue: MY_CUSTOM_FORMATS },
        DatePipe
    ]
})

export class MasterPopupComponent implements OnInit {
    public form: FormGroup;
    id: number;
    routeParams: any;
    public fields: any[] = [];
    selectedapplicationdetail: any[];
    applicationId: any;
    roleId: number;

    @ViewChild("editor") editor: GanttEditorComponent;
    public editorOptions: GanttEditorOptions;
    public chartdata: any;
    public pageType: any;
    pathname: any;
    districtId: any;
    regionList: any[];
    regionListCopy: any[];
    districtList: any[];
    districtListCopy: any[];
    talukList: any[];
    talukListCopy: any[];
    divisionList: any[];
    divisionListCopy: any[];
    firkaList: any[];
    firkaListCopy: any[];
    userId: number;
    minecodeList: any[];
    minecodeListCopy: any[];
    minerals_list: any;
    showMineral: boolean;
    minFromDate: string;
    minToDate: string;
    appDetail: any;
    getmicodeValue: any;
    minecodeObj: any;
    lease_period: any;
    mineralList: any;
    selectedMineralName: any;
    showGrid: boolean = false;
    jsonData: any;
    planPeriod: any;
    startDate: any;
    approvedQuantity: any[] = [];
    totalApprovedQuantity: number = 0;
    totalUsedQuantity: number = 0;
    mineralIndex: any;
    isExist: any;
    minor_mineral_day: any;
    minor_mineral_year: any;
    minor_mineral_month: any;
    application_id: any;
    mineral_id: any;
    lease_month: any;
    lease_days: any;
    UnitLabel: string = "";
    isReadOnly: boolean = false;
    limitLabel: boolean = false;
    graniteYears: any = 4;
    stockCodeObj: any;
    stockyardList: any[];
    stockyardListCopy: any[];
    stockyard_id: any;
    isSubmitted: boolean = false;
    constructor(
        private sessionService: UserSessionService,
        private formBuilder: FormBuilder,
        public datePipe: DatePipe,
        public router: Router,
        private regionService: RegionService,
        private alertService: AlertService,
        private registerService: RegisterService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<MasterPopupComponent>,
    ) {
        this.districtId = this.data.value;
        this.pageType = this.data.pagetype;
        this.pathname = this.data.pathname;
        if (this.pathname == 'mines') {
            if (this.pageType != 'add') {
                this.application_id = this.data.application_id;
                this.mineral_id = this.data.mineral_id;
            }
            if (this.pageType == 'view') {
                this.isReadOnly = true;
            } else {
                this.isReadOnly = false;
            }
        }
        else if (this.pathname == 'storage-quantity') {
            if (this.pageType != 'add') {
                this.stockyard_id = this.data.application_id;
                this.mineral_id = this.data.mineral_id;
            }
            if (this.pageType == 'view') {
                this.isReadOnly = true;
            } else {
                this.isReadOnly = false;
            }
        }
        this.roleId = this.sessionService.roleId();
        this.userId = this.sessionService.userId();
        this.showMineral = false;
        this.isSubmitted = false;
        var currentDate = new Date();
        this.minFromDate = moment(currentDate.setDate(currentDate.getDate() - 1)).format('YYYY-MM-DD');
        this.minToDate = moment(this.minFromDate).format('YYYY-MM-DD');
    }

    ngOnInit() {

        this.intializeValidators();
        if (this.pathname == 'districts') {
            this.getRegionList();
            if (this.pageType == 'update' || this.pageType == 'delete') {
                let req_data = {
                    id: this.districtId
                }
                this.getDistrictRecord(req_data);
            }
        } else if (this.pathname == 'taluks') {
            let req_data = {
            }
            this.getDistrictRecord(req_data);
            if (this.pageType == 'update' || this.pageType == 'delete') {
                let req_data = {
                    id: this.districtId
                }
                this.getTalukRecord(req_data);
            }
        }
        else if (this.pathname == 'villages') {
            let req_data = {
            }
            this.getDistrictRecord(req_data);
            if (this.pageType == 'update' || this.pageType == 'delete') {
                let request_data = {
                    id: this.districtId
                }
                this.getVillageRecord(request_data);
            }
        }
        else if (this.pathname == 'mines') {
            if (this.pageType == 'add') {
                this.regionService.getExistingMineCodes().subscribe(res => {
                    this.minecodeObj = res.Data;

                    this.minecodeList = [];
                    this.minecodeListCopy = [];
                    res.Data.forEach(element => {
                        this.minecodeList.push(element);
                    });
                    //this.minecodeList = res.Data;
                    this.minecodeList = _.orderBy(this.minecodeList, ['name'], ['asc']);
                    this.minecodeListCopy = this.minecodeList;
                });
            } else {
                this.regionService.editMineQuantity(this.application_id, this.mineral_id).subscribe(res => {
                    this.minecodeObj = res.Data;
                    this.isExist = res.Data.isExist;
                    this.form.patchValue(this.minecodeObj);
                    this.form.controls['isExist'].setValue(this.isExist);
                    this.form.controls['minecode'].setValue(this.application_id);
                    this.form.controls['minecode_value'].setValue(this.minecodeObj.minecode);
                    var i = 0;
                    this.jsonData = JSON.parse(res.Data.jsondata);
                    this.startDate = this.jsonData.mine_start_date;
                    if (this.minecodeObj.isExist || ('form_value' in this.jsonData)) {
                        this.isExist = "1";
                        this.form.controls['mineral_id'].setValue(this.minecodeObj.mineral_id);
                        (<FormArray>this.form.get('quantity_details')).clear();
                        this.mineralIndex = this.jsonData.form_value.minerals.findIndex(x => x === this.minecodeObj.mineral_id);
                        this.planPeriod = this.jsonData.form_value.mine_plan_period;
                        this.lease_month = this.jsonData.form_value.lease_month;
                        this.lease_days = this.jsonData.form_value.lease_days;
                        for (i = 0; i < parseInt(this.planPeriod); i++) {
                            this.addQuantityFormGroup();
                        }

                        for (i = 0; i < parseInt(this.planPeriod); i++) {
                            if (i < parseInt(this.planPeriod)) {
                                if (this.jsonData.form_value['showFinYears'] && i == 0) {
                                    (this.form.get('quantity_details') as FormArray).at(i)['controls'].start_date.setValue(this.jsonData.form_value['fin_start_date']);
                                }
                                else {
                                    (this.form.get('quantity_details') as FormArray).at(i)['controls'].start_date.setValue(this.addOneYearFrom(i, 1));
                                }
                                if (this.jsonData.form_value['showFinYears'] && (i == this.planPeriod - 1)) {
                                    (this.form.get('quantity_details') as FormArray).at(i)['controls'].end_date.setValue(this.jsonData.form_value['fin_end_date']);
                                }
                                else {
                                    (this.form.get('quantity_details') as FormArray).at(i)['controls'].end_date.setValue(this.addOneYear(i + 1, 1));
                                }
                                (this.form.get('quantity_details') as FormArray).at(i)['controls'].mineral_used_quantity.setValue(this.minecodeObj.quantity_details[i].used_quantity);
                                (this.form.get('quantity_details') as FormArray).at(i)['controls'].id.setValue(this.minecodeObj.quantity_details[i].id);
                                (this.form.get('quantity_details') as FormArray).at(i)['controls'].minecode.setValue(this.minecodeObj.minecode);
                                (this.form.get('quantity_details') as FormArray).at(i)['controls'].mineral_id.setValue(this.minecodeObj.mineral_id);
                                (this.form.get('quantity_details') as FormArray).at(i)['controls'].application_id.setValue(this.minecodeObj.application_id);
                                (this.form.get('quantity_details') as FormArray).at(i)['controls'].mineral_approved_quantity.setValue(this.minecodeObj.quantity_details[i].approved_quantity);
                                this.totalApprovedQuantity = (this.totalApprovedQuantity) + parseInt(this.minecodeObj.quantity_details[i].approved_quantity);
                                this.totalUsedQuantity = this.totalUsedQuantity + parseFloat(this.minecodeObj.quantity_details[i].used_quantity);

                            } else {
                                if (parseInt(this.planPeriod) > (this.minecodeObj.quantity_details).length) {
                                    (this.form.get('quantity_details') as FormArray).at(i)['controls'].start_date.setValue(this.addOneYearFrom(i, 1));
                                    (this.form.get('quantity_details') as FormArray).at(i)['controls'].end_date.setValue(this.addOneYear(i + 1, 1));

                                    var getQuantity = 'quantity_' + (this.mineralIndex + 1) + '_' + (i + 1);
                                    var quantityValue = this.jsonData.form_value[getQuantity] || '0';
                                    if (quantityValue) {
                                        this.approvedQuantity.push(quantityValue);
                                    } else {
                                        this.approvedQuantity.push(0);
                                    }

                                    (this.form.get('quantity_details') as FormArray).at(i)['controls'].mineral_approved_quantity.setValue(quantityValue);
                                    (this.form.get('quantity_details') as FormArray).at(i)['controls'].minecode.setValue(this.minecodeObj.minecode);
                                    (this.form.get('quantity_details') as FormArray).at(i)['controls'].mineral_id.setValue(this.minecodeObj.mineral_id);
                                    (this.form.get('quantity_details') as FormArray).at(i)['controls'].application_id.setValue(this.minecodeObj.application_id);
                                    this.totalApprovedQuantity = this.totalApprovedQuantity + parseInt(quantityValue);
                                }
                            }
                        }

                        if (this.lease_month && this.lease_month > 0) {
                            this.addQuantityFormGroup();
                            (this.form.get('quantity_details') as FormArray).at(parseInt(this.planPeriod))['controls'].start_date.setValue(this.addLastYearFrom(1, 1));
                            (this.form.get('quantity_details') as FormArray).at(parseInt(this.planPeriod))['controls'].end_date.setValue(this.addLastYearMonth(1, 1));

                            if ((parseInt(this.planPeriod) + 1) == this.minecodeObj.quantity_details.length) {

                                (this.form.get('quantity_details') as FormArray).at(this.minecodeObj.quantity_details.length - 1)['controls'].mineral_used_quantity.setValue(this.minecodeObj.quantity_details[this.minecodeObj.quantity_details.length - 1].used_quantity);
                                (this.form.get('quantity_details') as FormArray).at(this.minecodeObj.quantity_details.length - 1)['controls'].id.setValue(this.minecodeObj.quantity_details[this.minecodeObj.quantity_details.length - 1].id);
                                (this.form.get('quantity_details') as FormArray).at(this.minecodeObj.quantity_details.length - 1)['controls'].minecode.setValue(this.minecodeObj.minecode);
                                (this.form.get('quantity_details') as FormArray).at(this.minecodeObj.quantity_details.length - 1)['controls'].mineral_id.setValue(this.minecodeObj.mineral_id);
                                (this.form.get('quantity_details') as FormArray).at(this.minecodeObj.quantity_details.length - 1)['controls'].application_id.setValue(this.minecodeObj.application_id);
                                (this.form.get('quantity_details') as FormArray).at(this.minecodeObj.quantity_details.length - 1)['controls'].mineral_approved_quantity.setValue(this.minecodeObj.quantity_details[this.minecodeObj.quantity_details.length - 1].approved_quantity);
                                this.totalApprovedQuantity = (this.totalApprovedQuantity) + parseInt(this.minecodeObj.quantity_details[this.minecodeObj.quantity_details.length - 1].approved_quantity);
                                this.totalUsedQuantity = this.totalUsedQuantity + parseFloat(this.minecodeObj.quantity_details[this.minecodeObj.quantity_details.length - 1].used_quantity);
                            } else {
                                var getQuantity = '';
                                if (this.jsonData.form_value['is_ec_permitted'] == 'No') {
                                    getQuantity = 'ec_quantity_' + (this.mineralIndex + 1) + '_' + `${this.jsonData.form_value.mine_plan_period}` + 1;
                                } else {
                                    getQuantity = 'quantity_' + (this.mineralIndex + 1) + '_' + `${this.jsonData.form_value.mine_plan_period}` + 1;
                                }
                                var quantityValue = this.jsonData.form_value[getQuantity] || '0';
                                if (quantityValue) {
                                    this.approvedQuantity.push(quantityValue);
                                } else {
                                    this.approvedQuantity.push(0);
                                }

                                (this.form.get('quantity_details') as FormArray).at(parseInt(this.planPeriod))['controls'].mineral_approved_quantity.setValue(quantityValue);


                                (this.form.get('quantity_details') as FormArray).at(parseInt(this.planPeriod))['controls'].minecode.setValue(this.minecodeObj.minecode);
                                (this.form.get('quantity_details') as FormArray).at(parseInt(this.planPeriod))['controls'].mineral_id.setValue(this.minecodeObj.mineral_id);
                                (this.form.get('quantity_details') as FormArray).at(parseInt(this.planPeriod))['controls'].application_id.setValue(this.minecodeObj.application_id);
                                this.totalApprovedQuantity = this.totalApprovedQuantity + parseInt(quantityValue);
                            }

                        }

                        if (this.lease_days && this.lease_days != '' && this.lease_days != '0') {
                            this.addQuantityFormGroup();
                            (this.form.get('quantity_details') as FormArray).at(parseInt(this.planPeriod))['controls'].start_date.setValue(this.addLastYearFrom(1, 1));
                            (this.form.get('quantity_details') as FormArray).at(parseInt(this.planPeriod))['controls'].end_date.setValue(this.addLastYearDay(1, 1));

                            if ((parseInt(this.planPeriod) + 1) == this.minecodeObj.quantity_details.length) {

                                (this.form.get('quantity_details') as FormArray).at(this.minecodeObj.quantity_details.length - 1)['controls'].mineral_used_quantity.setValue(this.minecodeObj.quantity_details[this.minecodeObj.quantity_details.length - 1].used_quantity);
                                (this.form.get('quantity_details') as FormArray).at(this.minecodeObj.quantity_details.length - 1)['controls'].id.setValue(this.minecodeObj.quantity_details[this.minecodeObj.quantity_details.length - 1].id);
                                (this.form.get('quantity_details') as FormArray).at(this.minecodeObj.quantity_details.length - 1)['controls'].minecode.setValue(this.minecodeObj.minecode);
                                (this.form.get('quantity_details') as FormArray).at(this.minecodeObj.quantity_details.length - 1)['controls'].mineral_id.setValue(this.minecodeObj.mineral_id);
                                (this.form.get('quantity_details') as FormArray).at(this.minecodeObj.quantity_details.length - 1)['controls'].application_id.setValue(this.minecodeObj.application_id);
                                (this.form.get('quantity_details') as FormArray).at(this.minecodeObj.quantity_details.length - 1)['controls'].mineral_approved_quantity.setValue(this.minecodeObj.quantity_details[this.minecodeObj.quantity_details.length - 1].approved_quantity);
                                this.totalApprovedQuantity = (this.totalApprovedQuantity) + parseInt(this.minecodeObj.quantity_details[this.minecodeObj.quantity_details.length - 1].approved_quantity);
                                this.totalUsedQuantity = this.totalUsedQuantity + parseFloat(this.minecodeObj.quantity_details[this.minecodeObj.quantity_details.length - 1].used_quantity);
                            } else {
                                var getQuantity = '';
                                if (this.jsonData.form_value['is_ec_permitted'] == 'No') {
                                    getQuantity = 'day_ec_quantity_' + (this.mineralIndex + 1);
                                } else {
                                    getQuantity = 'day_quantity_' + (this.mineralIndex + 1);
                                }
                                var quantityValue = this.jsonData.form_value[getQuantity] || '0';
                                if (quantityValue) {
                                    this.approvedQuantity.push(quantityValue);
                                } else {
                                    this.approvedQuantity.push(0);
                                }

                                (this.form.get('quantity_details') as FormArray).at(parseInt(this.planPeriod))['controls'].mineral_approved_quantity.setValue(quantityValue);


                                (this.form.get('quantity_details') as FormArray).at(parseInt(this.planPeriod))['controls'].minecode.setValue(this.minecodeObj.minecode);
                                (this.form.get('quantity_details') as FormArray).at(parseInt(this.planPeriod))['controls'].mineral_id.setValue(this.minecodeObj.mineral_id);
                                (this.form.get('quantity_details') as FormArray).at(parseInt(this.planPeriod))['controls'].application_id.setValue(this.minecodeObj.application_id);
                                this.totalApprovedQuantity = this.totalApprovedQuantity + parseInt(quantityValue);
                            }

                        }
                        this.form.controls['quantity_details_old'].setValue(this.quantity_details);
                    }


                });
            }
        } else if (this.pathname == 'storage-quantity') {
            if (this.pageType == 'add') {
                this.regionService.getStockYardCodes().subscribe(res => {
                    if (res && res.isSuccess) {
                        this.stockCodeObj = res.Data;

                        this.stockyardList = res.Data;
                        this.stockyardListCopy = [];
                        // res.Data.forEach(element => {
                        //     this.minecodeList.push(element);
                        // });
                        //this.minecodeList = res.Data;
                        this.stockyardList = _.orderBy(this.stockyardList, ['minecode'], ['asc']);
                        this.stockyardListCopy = this.stockyardList;
                    }
                })
            } else {
                let data = {
                    stockyard_id: this.stockyard_id,
                    mineral_id: this.mineral_id
                }

                this.regionService.editstockqty(data).subscribe(res => {
                    if (res && res.isSuccess) {
                        this.stockCodeObj = res.Data;
                        this.form.addControl('id', new FormControl(''));
                        this.form.addControl('approved_quantity_old', new FormControl(''));
                        this.form.addControl('current_quantity_old', new FormControl(''));
                        this.form.patchValue(res.Data.quantity_details[0]);
                        this.form.get('minecode').setValue(res.Data.quantity_details[0].code);
                        this.form.get('approved_quantity_old').setValue(res.Data.quantity_details[0].approved_quantity);
                        this.form.get('current_quantity_old').setValue(res.Data.quantity_details[0].current_quantity);
                    }
                    else {
                        if (res && res.failures) {
                            this.alertService.error(res.failures.toString())
                        }
                    }
                })
            }
        }
    }

    get quantity_details() {
        return this.form.value.quantity_details as FormArray;
    }

    addLastYearFrom(dateValue, selectionValue) {

        var currentDate = new Date();
        let [d, m, y] = this.startDate.split('-')
        const dateObj = new Date(+y, +m - 1, +d)
        currentDate = new Date(dateObj);
        //currentDate = new Date(this.startDate);

        currentDate.setFullYear(currentDate.getFullYear() + parseInt(this.planPeriod));

        var minuesvalue = 0;
        // Subtract one day to get the desired output (2024-10-21)
        currentDate.setDate(currentDate.getDate() - parseInt("0"));

        // Format the date as "YYYY-MM-DD"
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    addLastYearMonth(dateValue, selectionValue) {

        var currentDate = new Date();
        let [d, m, y] = this.startDate.split('-')
        const dateObj = new Date(+y, +m - 1, +d)
        currentDate = new Date(dateObj);
        //currentDate = new Date(this.startDate);

        currentDate.setFullYear(currentDate.getFullYear() + parseInt(this.planPeriod));
        currentDate.setMonth(currentDate.getMonth() + parseInt(this.lease_month));
        var minuesvalue = 0;
        // Subtract one day to get the desired output (2024-10-21)
        //currentDate.setDate(currentDate.getDate() - parseInt("0"));
        currentDate.setDate(currentDate.getDate() - parseInt("1"));

        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    addLastYearDay(dateValue, selectionValue) {

        var currentDate = new Date();
        let [d, m, y] = this.startDate.split('-')
        const dateObj = new Date(+y, +m - 1, +d)
        currentDate = new Date(dateObj);

        currentDate.setFullYear(currentDate.getFullYear() + parseInt(this.planPeriod));
        currentDate.setDate(currentDate.getDate() + parseInt(this.lease_days));
        var minuesvalue = 0;
        // Subtract one day to get the desired output (2024-10-21)
        //currentDate.setDate(currentDate.getDate() - parseInt("0"));
        currentDate.setDate(currentDate.getDate() - parseInt("1"));

        // Format the date as "YYYY-MM-DD"

        // if((currentDate.getMonth() + 1 + parseInt(this.mineralform.value.lease_month)) >= 12){
        //   minuesvalue = (currentDate.getMonth() + 1 + parseInt(this.mineralform.value.lease_month)) - 12;
        //   currentDate.setFullYear(currentDate.getFullYear() + 1);
        //   currentDate.setDate(currentDate.getDate() - parseInt("1"));
        // }else{
        //   minuesvalue = (currentDate.getMonth() + 1 + parseInt(this.mineralform.value.lease_month));
        //   currentDate.setDate(currentDate.getDate() - parseInt("1"));
        // }
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    intializeValidators() {

        if (this.pathname == 'districts') {
            this.form = this.formBuilder.group({
                name: ['', [Validators.required, Validators.pattern('^[a-zA-Z \-\']+')]],
                code: ['', Validators.required],
                region_id: ['', Validators.required],

            });
        } else if (this.pathname == 'taluks') {
            this.form = this.formBuilder.group({
                name: ['', Validators.required],
                code: ['', Validators.required],
                district_id: ['', Validators.required],

            });
        } else if (this.pathname == 'villages') {
            this.form = this.formBuilder.group({
                name: ['', Validators.required],
                code: ['', Validators.required],
                district_id: ['', Validators.required],
                taluk_id: ['', Validators.required],
                division_id: [''],
                firka_id: [''],

            });
        }
        else if (this.pathname == 'mines') {
            this.form = this.formBuilder.group({
                minecode: ['', Validators.required],
                mineral_id: ['', Validators.required],
                minecode_value: [],
                isExist: [],

                minerals: this.formBuilder.array([this.createTransportFormGroup()]),

                //mineral_details: this.formBuilder.array([this.createTransportFormGroup()]),
                mineral_details: new FormArray([]),
                quantity_details: this.formBuilder.array([this.createQuantityFormGroup()]),
                quantity_details_old: this.formBuilder.array([]),
            });
            for (let i = 0; i <= 0; i++) {
                this.mineral_detailsform.push(this.createMineral_details());
            }
        }
        else if (this.pathname == 'storage-quantity') {
            this.form = this.formBuilder.group({
                minecode: [''],
                stockyard_id: ['', Validators.required],
                mineral_id: ['', Validators.required],
                // minecode_value: [],
                // isExist: [],
                //mineral_details: this.formBuilder.array([this.createTransportFormGroup()]),
                current_quantity: ['0', Validators.required],
                approved_quantity: ['0', Validators.required]
            });
        }
    }
    get formvalue() { return this.form.controls; }
    get mineral_detailsform() { return this.formvalue.mineral_details as FormArray; }
    get mineral_detailslist() { return this.mineral_detailsform.controls as FormGroup[]; }
    createMineral_details(): FormGroup {
        return this.formBuilder.group({
            //'minecode': new FormControl(''),
            //'application_id': new FormControl(''),
            //'mineral_id': new FormControl(''),
            // 'from_date': new FormControl(''),
            // 'to_date': new FormControl(''),
            // 'approved_quantity': new FormControl(''),
            // 'used_quantity': new FormControl(''),
            minecode: [''],
            application_id: [''],
            mineral_id: [''],
            from_date: ['', Validators.required],
            to_date: ['', Validators.required],
            approved_quantity: ['', [Validators.required, Validators.min(0)]],
            used_quantity: ['', [Validators.required, Validators.min(0)]],
        })
    }
    public addTransportFormGroup() {
        const mineral_details = this.form.get('mineral_details') as FormArray
        mineral_details.push(this.createMineral_details())
    }

    public removeOrClearTransport(i: number) {
        const mineral_details = this.form.get('mineral_details') as FormArray
        if (mineral_details.length > 1) {
            mineral_details.removeAt(i)
        } else {
            mineral_details.reset()
        }
    }

    public mineralChange(event: any, mineral_id, mineral_name) {
        this.showMineral = true;
        this.showGrid = true; var i = 0, k = 0;
        this.selectedMineralName = mineral_name;
        this.totalApprovedQuantity = 0;
        let mineralUnitLabel = "";

        this.regionService.getMineralUnit(mineral_id).subscribe((response) => {
            if (response && response.isSuccess) {
                mineralUnitLabel = response.Data.mineral_unit;
                this.UnitLabel = mineralUnitLabel;
            }
        });

        if (this.isExist || ('form_value' in this.jsonData)) {
            this.isExist = "1";
            (<FormArray>this.form.get('quantity_details')).clear();
            this.mineralIndex = this.jsonData.form_value.minerals.findIndex(x => x === mineral_id);

            for (i = 0; i < parseInt(this.planPeriod); i++) {
                // var getusedQuantity = 'used_quantity_'+(this.mineralIndex+1)+'_'+(i+1);
                // this.form.addControl(getusedQuantity, new FormControl('0'));
                this.addQuantityFormGroup();

            }
            this.approvedQuantity = [];
            this.totalApprovedQuantity = 0;
            this.totalUsedQuantity = 0;
            this.graniteYears = parseInt(this.jsonData.form_value.mine_plan_period) / 5;
            if (this.jsonData.form_value['rule'] == 107 || this.jsonData.form_value['rule'] == 117 || this.jsonData.form_value['rule'] == 118) {
                let index = 0;
                for (i = 0; i < this.graniteYears; i++) {
                    for (k = 0; k < 5; k++) {
                        var getQuantity = '', getusedQuantity = '';
                        if (this.jsonData.form_value['is_ec_permitted'] == 'No') {
                            getQuantity = 'quantity_' + (i + 1) + '_' + (this.mineralIndex + 1) + '_' + (k + 1);
                            getusedQuantity = 'used_quantity_' + (i + 1) + '_' + (this.mineralIndex + 1) + '_' + (k + 1);
                        } else {
                            getQuantity = 'quantity_' + (i + 1) + '_' + (this.mineralIndex + 1) + '_' + (k + 1);
                            getusedQuantity = 'used_quantity_' + (i + 1) + '_' + (this.mineralIndex + 1) + '_' + (k + 1);
                        }
                        var quantityValue = this.jsonData.form_value[getQuantity] || '0';
                        var usedquantityValue = this.jsonData.form_value[getusedQuantity] || '0';
                        if (quantityValue) {
                            this.approvedQuantity.push(quantityValue);
                        } else {
                            this.approvedQuantity.push(0);
                        }

                        (this.form.get('quantity_details') as FormArray).at(index)['controls'].start_date.setValue(this.addOneYearFrom(index, 1));
                        (this.form.get('quantity_details') as FormArray).at(index)['controls'].end_date.setValue(this.addOneYear(index + 1, 1));
                        (this.form.get('quantity_details') as FormArray).at(index)['controls'].mineral_approved_quantity.setValue(quantityValue);
                        (this.form.get('quantity_details') as FormArray).at(index)['controls'].mineral_used_quantity.setValue(usedquantityValue);
                        this.totalApprovedQuantity = this.totalApprovedQuantity + parseInt(quantityValue);
                        this.totalUsedQuantity = this.totalUsedQuantity + parseFloat(usedquantityValue);
                        index += 1;
                    }
                }
            } else {
                for (i = 0; i < parseInt(this.planPeriod); i++) {
                    var getQuantity = '';
                    if (this.jsonData.form_value['is_ec_permitted'] == 'No') {
                        getQuantity = 'ec_quantity_' + (this.mineralIndex + 1) + '_' + (i + 1);
                    } else {
                        getQuantity = 'quantity_' + (this.mineralIndex + 1) + '_' + (i + 1)
                    }
                    var quantityValue = this.jsonData.form_value[getQuantity] || '0';
                    if (quantityValue) {
                        this.approvedQuantity.push(quantityValue);
                    } else {
                        this.approvedQuantity.push(0);
                    }
                    if (this.jsonData.form_value['showFinYears'] && i == 0) {
                        (this.form.get('quantity_details') as FormArray).at(i)['controls'].start_date.setValue(this.jsonData.form_value['fin_start_date']);
                    }
                    else {
                        (this.form.get('quantity_details') as FormArray).at(i)['controls'].start_date.setValue(this.addOneYearFrom(i, 1));
                    }
                    if (this.jsonData.form_value['showFinYears'] && (i == this.planPeriod - 1)) {
                        (this.form.get('quantity_details') as FormArray).at(i)['controls'].end_date.setValue(this.jsonData.form_value['fin_end_date']);
                    }
                    else {
                        (this.form.get('quantity_details') as FormArray).at(i)['controls'].end_date.setValue(this.addOneYear(i + 1, 1));
                    }
                    (this.form.get('quantity_details') as FormArray).at(i)['controls'].mineral_approved_quantity.setValue(quantityValue);
                    this.totalApprovedQuantity = this.totalApprovedQuantity + parseInt(quantityValue);
                }
            }

            if (this.lease_month && this.lease_month > 0) {
                this.addQuantityFormGroup();
                var getQuantity = '';

                if (this.jsonData.form_value['is_ec_permitted'] == 'No') {
                    getQuantity = 'ec_quantity_' + (this.mineralIndex + 1) + '_' + (this.planPeriod) + 1;
                } else {
                    getQuantity = 'quantity_' + (this.mineralIndex + 1) + '_' + (this.planPeriod) + 1;
                }
                var quantityValue = this.jsonData.form_value[getQuantity] || '0';
                if (quantityValue) {
                    this.approvedQuantity.push(quantityValue);
                } else {
                    this.approvedQuantity.push(0);
                }

                (this.form.get('quantity_details') as FormArray).at(i)['controls'].start_date.setValue(this.addLastYearFrom(1, 1));
                (this.form.get('quantity_details') as FormArray).at(i)['controls'].end_date.setValue(this.addLastYearMonth(1, 1));
                (this.form.get('quantity_details') as FormArray).at(i)['controls'].mineral_approved_quantity.setValue(quantityValue);
                this.totalApprovedQuantity = this.totalApprovedQuantity + parseInt(quantityValue);
            }

            if (this.lease_days && this.lease_days != '' && this.lease_days != '0') {
                this.addQuantityFormGroup();
                var getQuantity = '';

                if (this.jsonData.form_value['is_ec_permitted'] == 'No') {
                    getQuantity = 'day_ec_quantity_' + (this.mineralIndex + 1);
                } else {
                    getQuantity = 'day_quantity_' + (this.mineralIndex + 1);
                }
                var quantityValue = this.jsonData.form_value[getQuantity] || '0';
                if (quantityValue) {
                    this.approvedQuantity.push(quantityValue);
                } else {
                    this.approvedQuantity.push(0);
                }

                (this.form.get('quantity_details') as FormArray).at(i)['controls'].start_date.setValue(this.addLastYearFrom(1, 1));
                (this.form.get('quantity_details') as FormArray).at(i)['controls'].end_date.setValue(this.addLastYearDay(1, 1));
                (this.form.get('quantity_details') as FormArray).at(i)['controls'].mineral_approved_quantity.setValue(quantityValue);
                this.totalApprovedQuantity = this.totalApprovedQuantity + parseInt(quantityValue);
            }

        }
    }

    stockYardMineralChange(mineral_id, mineral_name) {
        this.showMineral = true;
        this.showGrid = true;
        this.selectedMineralName = mineral_name;

        let data = {
            "stockyard_id": this.form.get('stockyard_id').value,
            "mineral_id": mineral_id
        }

        this.regionService.getMineralUnit(mineral_id).subscribe((response) => {
            if (response && response.isSuccess) {
                this.UnitLabel = response.Data.mineral_unit;
            }
        });

        this.regionService.getstockmineralqty(data).subscribe(response => {
            if (response && response.isSuccess) {
                if (response.Data?.yardMineralQty) {
                    this.form.get('current_quantity').setValue(response.Data.yardMineralQty);
                }
            }
        })
    }
    private createTransportFormGroup(): FormGroup {
        return this.formBuilder.group({
            'minecode': [''],
            'application_id': [''],
            'mineral_id': [''],
            'from_date': ['', Validators.required],
            'to_date': ['', Validators.required],
            'approved_quantity': ['', [Validators.required, Validators.min(0)]],
            'used_quantity': ['', [Validators.required, Validators.min(0)]],
        });
    }

    public addQuantityFormGroup() {
        const mineral_details = this.form.get('quantity_details') as FormArray;
        const old_mineral_details = this.form.get('quantity_details_old') as FormArray;
        mineral_details.push(this.createQuantityFormGroup());
        old_mineral_details.push(this.createQuantityFormGroup());
    }

    private createQuantityFormGroup(): FormGroup {

        if (this.pageType == 'add') {
            return new FormGroup({
                'year': new FormControl(''),
                'start_date': new FormControl(''),
                'end_date': new FormControl(''),
                'mineral_approved_quantity': new FormControl('0'),
                'mineral_used_quantity': new FormControl('0'),
            })
        } else {
            return new FormGroup({
                'id': new FormControl(''),
                'application_id': new FormControl(''),
                'start_date': new FormControl(''),
                'end_date': new FormControl(''),
                'minecode': new FormControl(''),
                'mineral_id': new FormControl(''),
                'mineral_approved_quantity': new FormControl('0'),
                'mineral_used_quantity': new FormControl('0'),
            })
        }

    }

    numSequenceEC(n: number): Array<number> {
        return Array(n);
    }

    strintoInt(val: string) {
        return parseInt(val);
    }

    calculateApprovedTotal(index: number) {
        this.totalApprovedQuantity = 0;
        var quantityArray = this.form.get('quantity_details') as FormArray;
        if (this.pageType == 'add') {
            for (let i = 0; i < quantityArray.length; i++) {
                var current_approved_qty = quantityArray.at(index).value.mineral_approved_quantity;
                var current_used_qty = quantityArray.at(index).value.mineral_used_quantity;
                if (parseInt(current_approved_qty) >= parseInt(current_used_qty)) {
                    this.totalApprovedQuantity = this.totalApprovedQuantity + (parseInt(quantityArray.at(i).value.mineral_approved_quantity));
                } else {
                    this.alertService.error('Please Check your Approved Quantity Limit...');
                    (this.form.get('quantity_details') as FormArray).at(index)['controls'].mineral_used_quantity.setValue('0');
                }

            }
        } else {
            for (let i = 0; i < quantityArray.length; i++) {
                var current_approved_qty = quantityArray.at(index).value.mineral_approved_quantity;
                var current_used_qty = quantityArray.at(index).value.mineral_used_quantity;
                if (parseInt(current_approved_qty) >= parseInt(current_used_qty)) {
                    this.totalApprovedQuantity = this.totalApprovedQuantity + (parseInt(quantityArray.at(i).value.mineral_approved_quantity));
                } else {
                    this.alertService.error('Please Check your Approved Quantity Limit...');
                    (this.form.get('quantity_details') as FormArray).at(index)['controls'].mineral_used_quantity.setValue('0');
                }

            }
        }

    }

    calculateUsedTotal(index: number) {
        this.totalUsedQuantity = 0;
        var quantityArray = this.form.get('quantity_details') as FormArray;
        if (this.pageType == 'add') {
            for (let i = 0; i < quantityArray.length; i++) {
                var current_approved_qty = quantityArray.at(index).value.mineral_approved_quantity;
                var current_used_qty = quantityArray.at(index).value.mineral_used_quantity;
                if ((this.totalApprovedQuantity) >= (this.totalUsedQuantity)) {
                    this.totalUsedQuantity = this.totalUsedQuantity + (parseFloat(quantityArray.at(i).value.mineral_used_quantity));
                    this.limitLabel = false;
                } else {
                    this.totalUsedQuantity = this.totalUsedQuantity + (parseFloat(quantityArray.at(i).value.mineral_used_quantity));
                    this.limitLabel = true;
                    this.alertService.error('Please Check your Approved Quantity Limit...');
                    //(this.form.get('quantity_details') as FormArray).at(index)['controls'].mineral_used_quantity.setValue('0');
                }

            }
            if ((this.totalApprovedQuantity) >= (this.totalUsedQuantity)) {
                this.limitLabel = false;
            } else {
                this.limitLabel = true;
                this.alertService.error('Please Check your Approved Quantity Limit...');
                //(this.form.get('quantity_details') as FormArray).at(index)['controls'].mineral_used_quantity.setValue('0');
            }
        } else {
            for (let i = 0; i < quantityArray.length; i++) {
                var current_approved_qty = quantityArray.at(index).value.mineral_approved_quantity;
                var current_used_qty = quantityArray.at(index).value.mineral_used_quantity;
                if ((this.totalApprovedQuantity) >= (this.totalUsedQuantity)) {
                    this.totalUsedQuantity = this.totalUsedQuantity + (parseFloat(quantityArray.at(i).value.mineral_used_quantity));
                    this.limitLabel = false;
                } else {
                    this.totalUsedQuantity = this.totalUsedQuantity + (parseFloat(quantityArray.at(i).value.mineral_used_quantity));
                    this.limitLabel = true;
                    this.alertService.error('Please Check your Approved Quantity Limit...');
                    //(this.form.get('quantity_details') as FormArray).at(index)['controls'].mineral_used_quantity.setValue('0');
                }
                // if (parseInt(current_approved_qty) >= parseInt(current_used_qty)) {
                //     this.totalUsedQuantity = this.totalUsedQuantity + (parseFloat(quantityArray.at(i).value.mineral_used_quantity));
                // } else {
                //     this.alertService.error('Please Check your Approved Quantity Limit...');
                //     (this.form.get('quantity_details') as FormArray).at(index)['controls'].mineral_used_quantity.setValue('0');
                // }

            }
            if ((this.totalApprovedQuantity) >= (this.totalUsedQuantity)) {
                this.limitLabel = false;
            } else {
                this.limitLabel = true;
                this.alertService.error('Please Check your Approved Quantity Limit...');
                //(this.form.get('quantity_details') as FormArray).at(index)['controls'].mineral_used_quantity.setValue('0');
            }
        }

    }

    addOneYear(dateValue, selectionValue) {

        var currentDate = new Date();
        let [d, m, y] = this.startDate.split('-')
        const dateObj = new Date(+y, +m - 1, +d)
        currentDate = new Date(dateObj);
        // currentDate = new Date(this.startDate);

        currentDate.setFullYear(currentDate.getFullYear() + parseInt(dateValue));

        currentDate.setDate(currentDate.getDate() - parseInt("1"));

        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;


    }

    addOneYearFrom(dateValue, selectionValue) {

        var currentDate = new Date();

        let [d, m, y] = this.startDate.split('-')
        const dateObj = new Date(+y, +m - 1, +d)
        currentDate = new Date(dateObj);

        currentDate.setFullYear(currentDate.getFullYear() + parseInt(dateValue));

        var minuesvalue = 0;
        // Subtract one day to get the desired output (2024-10-21)
        currentDate.setDate(currentDate.getDate() - parseInt("0"));

        // Format the date as "YYYY-MM-DD"
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    minecodeChange(event: any) {

        this.showGrid = false;
        this.form.controls['mineral_id'].reset();

        this.minecodeObj.forEach(field => {

            if (field.id == this.form.get('minecode').value) {
                this.jsonData = JSON.parse(field.jsondata);
                this.form.controls['minecode_value'].setValue(field.minecode);
                this.isExist = field.isExist;
                //this.form.controls['isExist'].setValue(this.minecodeObj.isExist);
                this.form.controls['isExist'].setValue(this.isExist);
                this.minerals_list = field.minerals;
                this.mineralList = field.minerals;
                this.getmicodeValue = field;
                this.appDetail = field;
                if (this.isExist || ('form_value' in this.jsonData)) {
                    this.lease_period = field.lease_period;
                    this.startDate = this.jsonData.mine_start_date;
                    this.planPeriod = this.jsonData.form_value.mine_plan_period;
                    this.lease_month = this.jsonData.form_value.lease_month;
                    this.lease_days = this.jsonData.form_value.lease_days;
                } else {
                    this.lease_period = field.lease_period;
                    this.minor_mineral_day = this.jsonData.minor_mineral_day;
                    this.minor_mineral_month = this.jsonData.minor_mineral_month;
                    this.minor_mineral_year = this.jsonData.minor_mineral_year;

                }

            }

        });

        // this.regionService.getapplicantionDetail(this.form.get('minecode').value, this.userId).subscribe(result => {

        //   if (result.isSuccess) {
        //     this.getmicodeValue = result.value;
        //     this.appDetail = result.value.Form;
        //     this.minerals_list = result.value.Form.minerals;
        //   }
        // });
    }

    stockCodeChange(event) {
        this.showGrid = false;
        this.form.controls['mineral_id'].reset();

        let stockYard = this.stockyardList.find(el => el.id == event.value)

        if (stockYard) {
            if (stockYard.yard_expiry == 0) {
                this.minerals_list = stockYard.minerals;
                this.mineralList = stockYard.minerals;

                this.form.controls['minecode'].setValue(stockYard.minecode);
            }
            else {
                this.alertService.error('The Stockyard License has been expired');
                this.form.controls['stockyard_id'].reset();
                this.minerals_list = null;
                this.mineralList = null;

                this.form.controls['minecode'].setValue('');
            }



        }
    }

    getTalukandDivision() {
        const result = {
            "district_id": this.form.controls['district_id'].value
        }
        this.getTalukRecord(result);
        this.registerService.getDivisionLookup(result).subscribe(divres => {
            if (divres && divres.isSuccess) {
                this.divisionList = [];
                this.divisionListCopy = [];
                this.divisionList = divres.value;
                this.divisionList = _.orderBy(this.divisionList, ['name'], ['asc']);
                this.divisionListCopy = this.divisionList;
            }
        });
        this.registerService.getFirkaLookup(result).subscribe(firkares => {
            if (firkares && firkares.isSuccess) {
                this.firkaList = [];
                this.firkaListCopy = [];
                this.firkaList = firkares.Data;
                this.firkaList = _.orderBy(this.firkaList, ['name'], ['asc']);
                this.firkaListCopy = this.firkaList;
            }
        });
    }

    getTalukRecord(result) {

        this.registerService.getTalukLookup(result).subscribe(res => {
            if (res && res.isSuccess) {
                if (this.pathname == 'taluks' && (this.pageType == 'update' || this.pageType == 'delete')) {
                    this.form.patchValue(res.value[0]);
                }
                this.talukList = [];
                this.talukListCopy = [];
                this.talukList = res.value;
                this.talukList = _.orderBy(this.talukList, ['name'], ['asc']);
                this.talukListCopy = this.talukList;
            } else {
                if (res && res.failures) {
                    this.alertService.error(res.failures.toString());
                }
            }
        });
    }

    getVillageRecord(result) {
        this.registerService.getVillageLookup(result).subscribe(res => {
            if (res && res.isSuccess) {
                if (this.pathname == 'villages' && (this.pageType == 'update' || this.pageType == 'delete')) {
                    this.form.patchValue(res.value[0]);
                    this.getTalukandDivision();
                }
            } else {
                if (res && res.failures) {
                    this.alertService.error(res.failures.toString());
                }
            }
        });

    }


    getRegionList() {

        this.selectedapplicationdetail = [];
        const req_data = {};
        this.regionService.getregionlist(req_data).subscribe(result => {

            if (result.isSuccess) {
                this.regionList = [];
                this.regionListCopy = [];
                this.regionList = result.Data;
                this.regionList = _.orderBy(this.regionList, ['name'], ['asc']);
                this.regionListCopy = this.regionList;
            } else {
                if (result && result.failures) {
                    this.alertService.error(result.failures.toString());
                }
            }
        });
    }

    getDistrictRecord(req_data) {

        this.regionService.getDistrictList(req_data).subscribe(result => {

            if (result.isSuccess) {
                this.districtList = [];
                this.districtListCopy = [];
                this.districtList = result.Data;
                this.districtList = _.orderBy(this.districtList, ['name'], ['asc']);
                this.districtListCopy = this.districtList;

                if (this.pathname == 'districts' && (this.pageType == 'update' || this.pageType == 'delete')) {
                    this.form.patchValue(result.Data[0]);
                }
            } else {
                if (result && result.failures) {
                    this.alertService.error(result.failures.toString());
                }
            }
        });
    }

    validateFormControl(form) {
        Object.keys(this[form].controls).forEach(field => {
            const control = this[form].get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({
                    onlySelf: true
                });
            } else if (control instanceof FormArray || control instanceof FormGroup) {
                if (control.markAllAsTouched) {
                    control.markAllAsTouched();
                }
            }
        })
    }

    onCancel() {
        this.dialogRef.close();
        this.router.navigate(['/master/' + this.pathname]);
        //window.location.reload();
        //this.ngOnInit();
    }
    onRefresh() {
        this.dialogRef.close();
        this.router.navigate(['/master/' + this.pathname]);
        window.location.reload();
    }

    onSubmit() {
        if (this.pathname == 'districts') {
            let req_data = {}
            if (this.pageType == 'add') {
                req_data = {
                    name: this.form.controls['name'].value,
                    code: this.form.controls['code'].value,
                    region_id: this.form.controls['region_id'].value,
                    id: 0,
                    action: this.pageType,
                }
            } else {
                req_data = {
                    name: this.form.controls['name'].value,
                    code: this.form.controls['code'].value,
                    region_id: this.form.controls['region_id'].value,
                    id: this.districtId,
                    action: this.pageType,
                }
            }
            this.regionService.districtSave(req_data).subscribe(result => {

                if (result && result.isSuccess) {
                    this.alertService.success(result.value.toString());
                    this.onRefresh();
                } else {
                    if (result && result.failures) {
                        this.alertService.error(result.failures.toString());
                    }
                }
            });
        } else if (this.pathname == 'taluks') {
            let req_data = {}
            if (this.pageType == 'add') {
                req_data = {
                    name: this.form.controls['name'].value,
                    code: this.form.controls['code'].value,
                    district_id: this.form.controls['district_id'].value,
                    id: 0,
                    action: this.pageType,
                }
            } else {
                req_data = {
                    name: this.form.controls['name'].value,
                    code: this.form.controls['code'].value,
                    district_id: this.form.controls['district_id'].value,
                    id: this.districtId,
                    action: this.pageType,
                }
            }
            this.regionService.talukSave(req_data).subscribe(result => {

                if (result && result.isSuccess) {
                    this.alertService.success(result.value.toString());
                    this.onRefresh();
                } else {
                    if (result && result.failures) {
                        this.alertService.error(result.failures.toString());
                    }
                }
            });
        } else if (this.pathname == 'villages') {
            let req_data = {}
            if (this.pageType == 'add') {
                req_data = {
                    name: this.form.controls['name'].value,
                    code: this.form.controls['code'].value,
                    district_id: this.form.controls['district_id'].value,
                    taluk_id: this.form.controls['taluk_id'].value,
                    division_id: this.form.controls['division_id'].value,
                    firka_id: this.form.controls['firka_id'].value,
                    id: 0,
                    action: this.pageType,
                }
            } else {
                req_data = {
                    name: this.form.controls['name'].value,
                    code: this.form.controls['code'].value,
                    district_id: this.form.controls['district_id'].value,
                    taluk_id: this.form.controls['taluk_id'].value,
                    division_id: this.form.controls['division_id'].value,
                    firka_id: this.form.controls['firka_id'].value === null ? '' : this.form.controls['firka_id'].value,
                    id: this.districtId,
                    action: this.pageType,
                }
            }
            this.regionService.villageSave(req_data).subscribe(result => {

                if (result && result.isSuccess) {
                    this.alertService.success(result.value.toString());
                    this.onRefresh();
                } else {
                    if (result && result.failures) {
                        this.alertService.error(result.failures.toString());
                    }
                }
            });
        } else if (this.pathname == 'mines') {
            this.isSubmitted = true;
            this.validateFormControl('form');

            if (!this.form.get('minecode').valid || !this.form.get('minecode').value) {
                this.form.get('minecode').markAsTouched();
                this.alertService.error('Mine Code is required');
                return;
            }

            if (!this.form.get('mineral_id').valid || !this.form.get('mineral_id').value) {
                this.form.get('mineral_id').markAsTouched();
                this.alertService.error('Mineral selection is required');
                return;
            }

            const mineral_details = this.form.get('mineral_details') as FormArray;
            const quantity_details = this.form.get('quantity_details') as FormArray;

            if (!this.isExist) {
                if (!mineral_details || mineral_details.length === 0) {
                    this.alertService.error('Please add mineral details');
                    return;
                }

                let hasError = false;
                for (let i = 0; i < mineral_details.length; i++) {
                    const row = mineral_details.at(i) as FormGroup;
                    if (row.markAllAsTouched) {
                        row.markAllAsTouched();
                    }

                    const fromDate = row.get('from_date')?.value;
                    const toDate = row.get('to_date')?.value;
                    const approvedQty = row.get('approved_quantity')?.value;
                    const usedQty = row.get('used_quantity')?.value;

                    if (!fromDate) {
                        this.alertService.error('From Date is required');
                        hasError = true;
                        break;
                    }
                    if (!toDate) {
                        this.alertService.error('To Date is required');
                        hasError = true;
                        break;
                    }
                    if (approvedQty === null || approvedQty === undefined || approvedQty === '' || isNaN(Number(approvedQty))) {
                        this.alertService.error('Approved Quantity is required');
                        hasError = true;
                        break;
                    }
                    if (usedQty === null || usedQty === undefined || usedQty === '' || isNaN(Number(usedQty))) {
                        this.alertService.error('Used Quantity is required');
                        hasError = true;
                        break;
                    }
                    if (parseFloat(usedQty) < 0) {
                        this.alertService.error('Used Quantity cannot be negative');
                        hasError = true;
                        break;
                    }
                    if (parseFloat(approvedQty) < 0) {
                        this.alertService.error('Approved Quantity cannot be negative');
                        hasError = true;
                        break;
                    }
                    if (parseFloat(usedQty) > parseFloat(approvedQty)) {
                        this.alertService.error('Used Quantity cannot exceed Approved Quantity');
                        hasError = true;
                        break;
                    }
                }
                if (hasError) {
                    return;
                }

                for (let i = 0; i < mineral_details.length; i++) {
                    let req_from = mineral_details.value[i].from_date;
                    let req_to = mineral_details.value[i].to_date;
                    (this.form.get('mineral_details') as FormArray).at(i)['controls'].from_date.setValue(moment(req_from).format('YYYY-MM-DD'));
                    (this.form.get('mineral_details') as FormArray).at(i)['controls'].to_date.setValue(moment(req_to).format('YYYY-MM-DD'));
                    (this.form.get('mineral_details') as FormArray).at(i)['controls'].application_id.setValue(this.appDetail?.id || this.form.get('minecode').value);
                    (this.form.get('mineral_details') as FormArray).at(i)['controls'].mineral_id.setValue(this.form.get('mineral_id').value);
                    (this.form.get('mineral_details') as FormArray).at(i)['controls'].minecode.setValue(this.getmicodeValue?.minecode || this.form.get('minecode_value').value);
                }
            } else {
                if (!quantity_details || quantity_details.length === 0) {
                    this.alertService.error('Quantity details required');
                    return;
                }
                let hasError = false;
                for (let i = 0; i < quantity_details.length; i++) {
                    const row = quantity_details.at(i) as FormGroup;
                    if (row.markAllAsTouched) {
                        row.markAllAsTouched();
                    }
                    const usedQty = row.get('mineral_used_quantity')?.value;
                    if (usedQty === null || usedQty === undefined || usedQty === '' || isNaN(Number(usedQty))) {
                        this.alertService.error('Used Quantity is required');
                        hasError = true;
                        break;
                    }
                    if (parseFloat(usedQty) < 0) {
                        this.alertService.error('Used Quantity cannot be negative');
                        hasError = true;
                        break;
                    }
                }
                if (hasError) {
                    return;
                }
                if (this.limitLabel) {
                    this.alertService.error('Limit Mismatched');
                    return;
                }
            }

            if (this.pageType == 'add') {
                if (!this.limitLabel) {
                    this.regionService.mineralSave(this.form.value).subscribe(result => {
                        if (result && result.isSuccess) {
                            this.alertService.success("Data added successfully");
                            this.onRefresh();
                        } else {
                            if (result && result.failures) {
                                this.alertService.error(result.failures.toString());
                            } else if (result && result.message) {
                                this.alertService.error(result.message);
                            }
                        }
                    }, error => {
                        this.alertService.error(error?.error?.message || 'Failed to save mineral data');
                    });
                } else {
                    this.alertService.error("Limit Mismatched");
                }
            } else {
                if (!this.limitLabel) {
                    this.regionService.mineQuantityUpdate(this.form.value).subscribe(result => {
                        if (result && result.isSuccess) {
                            this.alertService.success("Data Updated successfully");
                            this.onRefresh();
                        } else {
                            if (result && result.failures) {
                                this.alertService.error(result.failures.toString());
                            } else if (result && result.message) {
                                this.alertService.error(result.message);
                            }
                        }
                    }, error => {
                        this.alertService.error(error?.error?.message || 'Failed to update mineral data');
                    });
                } else {
                    this.alertService.error("Limit Mismatched");
                }
            }

        } else if (this.pathname == 'storage-quantity') {
            if (this.form.valid) {
                if (this.pageType == 'add') {
                    this.regionService.stockqtysave(this.form.value).subscribe(res => {
                        if (res && res.isSuccess) {
                            this.alertService.success("Data added successfully");
                            this.onRefresh();

                        }
                        else {
                            if (res && res.failures) {
                                this.alertService.error(res.failures.toString());
                            }
                        }
                    })
                } else {
                    this.regionService.stockqtyupdate(this.form.value).subscribe(result => {
                        if (result && result.isSuccess) {
                            this.alertService.success("Data Updated successfully");
                            this.onRefresh();
                        }
                    });
                }
            }
            else {
                this.alertService.error('Plese fill all mandatory fields');
            }
        }

    }
    letterOnly(event) {
        var charCode = event.keyCode;
        if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8 || charCode == 32)

            return true;
        else
            return false;
    }

    validateCurrent() {
        if (this.form.get('current_quantity').value) {
            let approved = parseFloat(this.form.get('approved_quantity').value);
            let current = parseFloat(this.form.get('current_quantity').value);

            if (current > approved) {
                this.alertService.error('Available Quantity exceeds Approved Quantity, Plese provide valid quantities');
                this.form.get('current_quantity').setValue('');
                // if (this.stockCodeObj?.quantity_details) {
                //     this.form.get('current_quantity').setValue('');
                // }
                // else {
                //     this.form.get('current_quantity').setValue('');
                // }
            }
        }
        else {
            this.form.get('current_quantity').setValue('');
            // if (this.stockCodeObj?.quantity_details) {
            //     this.form.get('current_quantity').setValue('');
            // }
            // else {
            //     this.form.get('current_quantity').setValue('');
            // }

        }
    }

    validateApproved() {
        if (this.form.get('approved_quantity').value) {
            let approved = parseFloat(this.form.get('approved_quantity').value);
            let current = parseFloat(this.form.get('current_quantity').value);

            if (current > approved) {
                this.alertService.error('Available Quantity exceeds Approved Quantity, Plese provide valid quantities');
                this.form.get('current_quantity').setValue('');
                // if (this.stockCodeObj?.quantity_details) {
                //     this.form.get('current_quantity').setValue('');
                // }
                // else {
                //     this.form.get('current_quantity').setValue('');
                // }
            }
        }
        else {
            this.form.get('approved_quantity').setValue('');

            // if (this.stockCodeObj?.quantity_details) {
            //     this.form.get('approved_quantity').setValue('');
            // }
            // else {
            //     this.form.get('approved_quantity').setValue('');
            // }
        }

    }
}